<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='链接配置'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="3">
          <el-button type="primary" @click="showAddDialog">添加链接配置</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="configLinkList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column prop="title" label="标题" align="center"></el-table-column>
      <el-table-column prop="content" label="链接" align="center"></el-table-column>
      <el-table-column prop="hits" label="点击量" align="center"></el-table-column>
      <el-table-column label="模块" align="center">
        <template slot-scope="scope">
          {{scope.row.m_id | mIdToName}}
        </template>
      </el-table-column>
      <el-table-column label="日期" align="center">
        <template slot-scope="scope">
          {{scope.row.day_time | dateFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <config-link-add :visible="addDialogAvaible"
      :id="currentId"
      :mIdList="mIdList"
      @add="add"
      @update="update"
      @close="closeAddDialog">
    </config-link-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ConfigLinkAdd from './configLinkAdd.vue'
let that = this
export default {
  name: 'config_link_list',
  components: {
    'bread-crumb': BreadCrumb,
    'config-link-add': ConfigLinkAdd
  },
  created () {
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      configLinkList: [],
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      },
      addDialogAvaible: false,
      mIdList: [
        { id: 1, name: '读经助手' },
        { id: 2, name: '读圣经吧' },
        { id: 3, name: '读圣亮光' }
      ]
    }
  },
  beforeCreate () {
    that = this
  },
  filters: {
    mIdToName (id) {
      let result = ''
      that.mIdList.forEach((v) => {
        if (id === v.id) {
          result = v.name
        }
      })
      return result
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/config_link/list', this.param)
      if (res.code === 0) {
        this.configLinkList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    async add (data) {
      const res = await this.$http.post('/admin/config_link/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/config_link/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/config_link/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
